import { helper } from '@ember/component/helper';
import { getColorFromInitiativeTitle } from 'scaleflow/utils/colorClasses';

export default helper(function titleToBg([initiative]) {
  return getColorFromInitiativeTitle(initiative);
});
